<template>
  <div class="wrapper">
    <div class="title">
      {{ `${$t('重置登录密码')}（2/3)` }}
    </div>
    <!-- 手机扫码 -->
    <div class="qrcode">
      <div ref="qrcodeImg" class="qrcode-img"></div>
      <p
        class="qrcode-text">
        {{ $t('手机扫码完成人脸识别') }}
      </p>
    </div>
    <BackButton
      @click="handleBack"/>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import QRCode from '@/utils/qrcode'
import loginApi from '@/api/login'
export default {
  data () {
    return {
      // 二维码实例
      qrcode: null,
      // face++验证网址
      faceURL: 'https://api.megvii.com/faceid/lite/do',
      // 验证结果30s后查询一次
      queryTimeout: 5000,
      // 3s轮询一次
      pollTimeout: 3000
    }
  },
  computed: {
    ...mapState('login', ['userInfo', 'faceToken'])
  },
  mounted () {
    const target = this.$refs.qrcodeImg
    const { faceURL, faceToken } = this
    this.qrcode = new QRCode(target, {
      text: `${faceURL}?token=${faceToken}`,
      width: 150,
      height: 150,
      colorDark: '#000000',
      colorLight: '#ffffff',
      correctLevel: QRCode.CorrectLevel.H
    })
    this.createTimer(this.getResultOfFaceId, this.queryTimeout)()
  },
  methods: {
    ...mapMutations('login', ['SET_RESET_STATE', 'SET_FACE_SESSION']),
    // 创建一个唯一的定时器
    createTimer (callback, timeout) {
      let timer = null
      return () => {
        if (timer) {
          clearTimeout(timer)
        }
        timer = setTimeout(() => {
          callback && callback()
          clearTimeout(timer)
        }, timeout)
      }
    },
    // 获取 face++ 判定结果
    getResultOfFaceId () {
      const { customerId: cstId, userId } = this.userInfo
      loginApi.getResultOfFaceId({
        cstId,
        userId,
        needToken: true
      }).then(res => {
        if (res) {
          const { ec, data } = res
          if (ec === 'FACE_RESULT_PENDING') {
            // 人脸识别结果处理中
            this.createTimer(this.getResultOfFaceId, this.pollTimeout)()
          } else if (ec === '0') {
            const { result, faceSession, faceToken } = data
            if (result) {
              // 验证通过
              this.SET_FACE_SESSION(faceSession)
              this.SET_RESET_STATE('stepThree')
            } else {
              // 验证失败
              this.qrcode.clear()
              this.qrcode.makeCode(`${this.faceURL}?token=${faceToken}`)
              this.createTimer(this.getResultOfFaceId, this.queryTimeout)()
              this.$talert('人脸识别失败。可重新扫码识别或返回登录页面。', '系统提示')
            }
          }
        }
      }).catch(err => {
        console.error(err)
      })
    },
    handleBack () {
      this.SET_RESET_STATE('stepOne')
      // FIXME: 该页计划用websocket优化体验 目前组件销毁时 没有销毁定时器
    }
  }
}
</script>

<style scoped lang="less">
.wrapper {
  padding: 62px 34px 0;
  .title {
    text-align: left;
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #131523;
    line-height: 20px;
  }
  .text {
    margin: 35px 0 20px;
    font-size: 14px;
    font-weight: 400;
    color: #333752;
    line-height: 14px;
  }
  .input {
    width: 200px;
    height: 46px;
    line-height: 46px;
    text-align: left;
  }
  .qrcode {
    margin-top: 100px;
    .qrcode-img {
      width: 150px;
      height: 150px;
      margin: 0 auto;
    }
    .qrcode-text {
      margin-top: 39px;
      font-size: 14px;
      font-weight: 400;
      color: #5A607F;
      line-height: 14px;
    }
  }
}
</style>
